import React from 'react';
import { AllGames } from './AllGames';
import { FeaturedGame } from './FeaturedGame';
import SiteHead from './SiteHead';

const Home = () => {
    return (
        <div>
            {<SiteHead />}

            <FeaturedGame />
            <AllGames/>

            
{/* <TitlesWrapper/> */}

        </div>
    )
}

export default Home
